import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";

const COUNTRY_SELECT_POPUP_INDICATOR_SX = {
    color: colors.text.muted,
    padding: "0.15rem",
    transform: "none",
    transition: "color 0.15s ease-in-out",
    "&:hover": {
        backgroundColor: "transparent",
        color: colors.text.primary,
    },
    "&.MuiAutocomplete-popupIndicatorOpen": {
        transform: "none",
    },
    "& .country-select-arrow-down": {
        display: "inline-flex",
        fontSize: "1.25rem",
    },
    "& .country-select-arrow-up": {
        display: "none",
        fontSize: "1.25rem",
    },
    "&.MuiAutocomplete-popupIndicatorOpen .country-select-arrow-down": {
        display: "none",
    },
    "&.MuiAutocomplete-popupIndicatorOpen .country-select-arrow-up": {
        display: "inline-flex",
    },
};

const COUNTRY_SELECT_FIELD_BASE_SX = {
    "& .MuiOutlinedInput-root": {
        background: colors.background.surface,
        transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        "& fieldset": {
            borderColor: colors.border.default,
            borderWidth: "1px",
        },
        "&:hover fieldset": {
            borderColor: alpha(colors.primary.main, 0.55),
        },
        "&.Mui-focused": {
            boxShadow: `0 0 0 3px ${alpha(colors.primary.main, 0.1)}`,
        },
        "&.Mui-focused fieldset": {
            borderColor: alpha(colors.primary.main, 0.55),
            borderWidth: "1px",
        },
    },
    "& .MuiOutlinedInput-input": {
        color: colors.text.primary,
        fontFamily: "inherit",
        "&::placeholder": {
            color: colors.text.muted,
            opacity: 1,
        },
    },
    "& .MuiAutocomplete-endAdornment": {
        right: { xs: "0.35rem", sm: "0.7rem" },
    },
    "& .MuiAutocomplete-popupIndicator": COUNTRY_SELECT_POPUP_INDICATOR_SX,
};

export const COUNTRY_SELECT_FIELD_SX = {
    minWidth: { xs: "9.5rem", sm: "17.5rem" },
    maxWidth: { xs: "100%", sm: "22rem" },
    flex: { xs: "1 1 auto", sm: "0 0 auto" },
    padding: 0,
    flexShrink: { xs: 1, sm: 0 },
    ...COUNTRY_SELECT_FIELD_BASE_SX,
    "& .MuiOutlinedInput-root": {
        ...COUNTRY_SELECT_FIELD_BASE_SX["& .MuiOutlinedInput-root"],
        borderRadius: { xs: "10px", sm: "14px" },
        minHeight: { xs: "2.1rem", sm: "2.8rem" },
        padding: { xs: "0.45rem 0.7rem", sm: "0.9rem 1.1rem" },
    },
    "& .MuiOutlinedInput-input": {
        ...COUNTRY_SELECT_FIELD_BASE_SX["& .MuiOutlinedInput-input"],
        fontSize: { xs: "0.8rem", sm: "0.95rem" },
        padding: "0 !important",
        marginLeft: { xs: "0.15rem", sm: "0.25rem" },
    },
};

export const COUNTRY_SELECT_PAPER_SX = {
    backgroundColor: colors.background.dark,
    border: `1px solid ${colors.border.default}`,
    borderRadius: "14px",
    mt: "0.35rem",
    boxShadow: "0 12px 32px rgba(0,0,0,0.45)",
    backgroundImage: "none",
};

export const COUNTRY_SELECT_LISTBOX_SX = {
    maxHeight: "18.5rem",
    overflowY: "auto",
    overscrollBehavior: "contain",
    py: 0,
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255,255,255,0.18) transparent",
    "&::-webkit-scrollbar": {
        width: 6,
    },
    "&::-webkit-scrollbar-track": {
        background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(255,255,255,0.16)",
        borderRadius: 999,
    },
    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "rgba(255,255,255,0.28)",
    },
    "& .MuiAutocomplete-option": {
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
        fontSize: {
            xs: "0.85rem",
            sm: "0.95rem",
        },
        minHeight: {
            xs: "2.5rem",
            sm: "auto",
        },
        py: {
            xs: "0.45rem",
            sm: "0.6rem",
        },
        color: colors.text.primary,
        '&[aria-selected="true"]': {
            backgroundColor: `${alpha(colors.primary.main, 0.24)} !important`,
            color: colors.accent.main,
        },
        "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.05)",
        },
        '&[aria-selected="true"].Mui-focused': {
            backgroundColor: `${alpha(colors.primary.main, 0.32)} !important`,
        },
        "&:hover": {
            backgroundColor: "rgba(255,255,255,0.05)",
        },
    },
};
